import React from 'react'
import { Redirect } from 'react-router-dom'
import Header from '../../../containers/HeaderContainer'
import HeaderUser from '../../../containers/HeaderUserContainer'
import Progress from '../../../components/Progress'
import auth from '../../../modules/auth'
import config from '../../../modules/config'

import './EmailConfirmation.scss'

class EmailConfirmation extends React.Component {
  render() {
    if (!this.props.email) {
      return <Redirect to="/signup" />
    }

    return (
      <div className="email-confirmation">
        {auth.loggedIn() ?
          <HeaderUser
            {...this.props}
            hideInfo={true}
            hideChat={true}
          />
          :
          <Header/>
        }

        <Progress {...this.props} />
        <div className="email-confirmation__wrapper">
          <div className="email-confirmation__content">
            <h2 className="email-confirmation__title">新規会員登録</h2>
            <div className="email-confirmation__container gray">
              <h3>確認のメールを送信しました</h3>
              <div className="email-confirmation__message">
                下記のメールアドレス宛に、本人認証のためのメールをお送りしました。メール内の「認証」ボタンをクリックしてメールアドレスの認証をしてください。
              </div>
              <h3 className="email-confirmation__email-icon">本人認証メール送信先</h3>
              <p>{this.props.email}</p>
            </div>
            <p className="email-confirmation__edit-comment">
              メールが届かない場合は迷惑メールフォルダをご確認ください。<br/>
              数分経っても届かない場合は、メールアドレスをご確認のうえ<a href="/signup">新規登録画面</a>から再度ご登録ください。
            </p>
            <a
              href="/"
              className="email-confirmation__button custom-control-button">
              トップページへ
            </a>
            <iframe title="pardot-form" src={`${config.formHandlerEndpoint}?email=${this.props.email}&source=findme.life`} width="1" height="1" style={{border: 0}}></iframe>
          </div>
        </div>
      </div>
    )
  }
}

export default EmailConfirmation



// WEBPACK FOOTER //
// ./src/routes/emailConfirmation/components/EmailConfirmation.js